export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/5640253749f57ce229257494a6b0bc26.svg";